export default {
  name: 'marking--orderType',
};